import { createSelector, Selector } from 'reselect';
import { State } from '../../../reducers';
import * as R from 'ramda';
import { selectCurrentCaseCustomDistribution } from './customDistribution.selector';

export const selectCurrentCaseHasCustomDistribution: Selector<State, boolean> = createSelector(
  [selectCurrentCaseCustomDistribution],
  (customDistribution) => !R.isEmpty(customDistribution)
);
